import { EPage } from '@types';
import { getEnum, isInEnum } from '@utils/enumerators';

import { pathRegexPattern } from './constants';

export const getPageFromRoute = (path: string): EPage | null => {
  const currentPath = pathRegexPattern.exec(path);

  if (!currentPath?.[1]) {
    return null;
  }

  const pathValue = currentPath[1].toUpperCase();

  return isInEnum(EPage, pathValue) ? getEnum(EPage, pathValue) : null;
};
